import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { useFetch } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";

export default function CaseStudyNav({ currentSlug }) {
  const { data: all } = useFetch("/case-studies");
  const list = all || [];
  const idx = list.findIndex((c) => c.slug === currentSlug);
  const next = list.length > 1 && idx !== -1 ? list[(idx + 1) % list.length] : null;

  return (
    <section data-testid="case-study-nav" className="border-t border-ash">
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-16 md:grid-cols-12 md:px-10 md:py-24">
        <div className="md:col-span-4">
          <Link
            to="/case-studies"
            data-testid="case-nav-all"
            className="group inline-flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.16em] text-obsidian transition-colors duration-200 hover:text-progress"
          >
            <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
            All case studies
          </Link>
        </div>

        {next && (
          <Reveal className="md:col-span-8">
            <Link
              to={`/case-studies/${next.slug}`}
              data-testid="case-nav-next"
              className="group grid gap-6 border border-ash bg-paper p-6 transition-colors duration-300 hover:border-obsidian sm:grid-cols-[160px_1fr] md:p-8"
            >
              {next.cover_image && (
                <div className="overflow-hidden">
                  <img
                    src={next.cover_image}
                    alt=""
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover grayscale transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
              )}
              <div className="flex flex-col justify-between gap-6">
                <div>
                  <p className="text-[13px] font-bold uppercase tracking-[0.2em] text-slategray">
                    Next case study
                    {next.industry && <span className="ml-3 text-progress">{next.industry}</span>}
                  </p>
                  <h3 className="mt-3 font-serif text-2xl font-medium leading-tight tracking-tight md:text-3xl">{next.title}</h3>
                </div>
                <span className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.16em] text-obsidian group-hover:text-progress">
                  Read next
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
